import { defineFcm } from '../shared/factory';

export const FCM_ENABLE_VISION_FE_HELLOWORLD = defineFcm('enable_vision_fe_helloworld')
	.asBoolean()
	.withDefault(false)
	.toConfig();
